import { gql } from '@apollo/client';
import dealData from '../../../gqlCommon/graphql/fragments/deal/dealData';

const deal = {
  CREATE_DEAL: gql`
    ${dealData.DEAL_DATA}
    mutation CreateDealFromCarId(
      $selectedCar: SelectedCarForDeal
      $financeFormInput: FinanceFormInput
      $journeyType: JourneyType!
      $postCode: String
      $insuranceFormInput: InsuranceFormInput
      $dealerId: String
      $utmDetailsInput: UTMDetailsInput
    ) {
      createDealFromCarId(
        selectedCar: $selectedCar
        financeFormInput: $financeFormInput
        journeyType: $journeyType
        postCode: $postCode
        insuranceFormInput: $insuranceFormInput
        dealerId: $dealerId
        utmDetailsInput: $utmDetailsInput
      ) {
        ...DealData
      }
    }
  `,
};

export default deal;
